// src/utils/instrument-types.js
//
// Tipos (magnitudes) de instrumento. Fuente única: la usan el alta de
// instrumentos y el buscador de certificados. Los `value` son los que están
// guardados en instruments.type.

export const INSTRUMENT_TYPE_OPTIONS = [
  { value: 'pressure', label: 'Presión' },
  { value: 'temperature', label: 'Temperatura' },
  { value: 'electrical', label: 'Eléctrica' },
  { value: 'dimensional', label: 'Dimensional / Longitud' },
  { value: 'balance', label: 'Balanza (histórico)' },
  { value: 'mass', label: 'Masa / Balanzas / Pesas' },
  { value: 'flow', label: 'Caudal' },
  { value: 'force', label: 'Fuerza / Torque' },
  { value: 'gas', label: 'Gases' },
  { value: 'sound', label: 'Nivel sonoro (decibelímetros)' },
  { value: 'illuminance', label: 'Iluminancia (lux)' },
  { value: 'air_velocity', label: 'Velocidad de aire (anemómetros)' },
  { value: 'analytic', label: 'Analítica (pH, conductividad, etc.)' },
  { value: 'other', label: 'Otro / No clasificado' },
];

export function instrumentTypeLabel(value) {
  return INSTRUMENT_TYPE_OPTIONS.find((o) => o.value === value)?.label || value || '—';
}
